import React from 'react';
import slColors from 'sl-colors';

// maybe get metadata here
interface WorkingStylesCellProps {
  lowerLimit: number;
  upperLimit: number;
  // TODO: hardcoding this to receive two groups only, think it's ok for now so I don't have to do some weird logic to accept any
  groupOneValue?: number;
  groupTwoValue?: number;
  selectedValue?: number;
  style?: React.CSSProperties;
  isEditable?: boolean;
  selectNewValue?: (value: number) => void;
  isFlipped?: boolean;
}

const isWithinBounds = (lowerLimit: number, upperLimit: number, value?: number) => {
  if (!value) return false;
  return value >= lowerLimit && value <= upperLimit;
};

const WorkingStylesCell = ({
  lowerLimit,
  upperLimit,
  selectedValue,
  groupOneValue,
  groupTwoValue,
  style = {},
  isEditable = false,
  selectNewValue,
  isFlipped,
}: WorkingStylesCellProps) => {
  const isSelected = isWithinBounds(lowerLimit, upperLimit, selectedValue);
  const hasGroupOne = isWithinBounds(lowerLimit, upperLimit, groupOneValue);
  const hasGropTwo = isWithinBounds(lowerLimit, upperLimit, groupTwoValue);

  const hasBothGroups = hasGroupOne && hasGropTwo;

  const handleEdit = (value: number) => {
    if (!isEditable) return;
    selectNewValue?.(value);
  };

  const isSelectedUI = (
    <div
      className="tw-rounded-sm tw-bg-success-300 tw-aspect-square tw-w-2/3 tw-absolute tw-top-1/2 tw-left-1/2"
      style={{ transform: 'translate(-50%, -50%)' }}
    />
  );

  const bothGroupsUI = (
    <div
      className="tw-rounded-full tw-border-2 tw-border-gray-700 tw-aspect-square tw-w-[16px] tw-absolute tw-top-1/2 tw-left-1/2"
      style={{
        transform: 'translate(-50%, -50%)',
        background: isFlipped
          ? `linear-gradient(90deg, white, white 49%, ${slColors.gray[700]} 51%)`
          : `linear-gradient(90deg, ${slColors.gray[700]}, ${slColors.gray[700]} 49%, white 51%)`,
      }}
    />
  );

  const groupOneUI = (
    <div
      className="tw-rounded-full tw-bg-gray-700 tw-border-2 tw-border-gray-700 tw-aspect-square tw-w-[16px] tw-absolute tw-top-1/2 tw-left-1/2"
      style={{ transform: 'translate(-50%, -50%)' }}
    />
  );

  const groupTwoUI = (
    <div
      className="tw-rounded-full tw-bg-white tw-border-2 tw-border-gray-600 tw-aspect-square tw-w-[16px] tw-absolute tw-top-1/2 tw-left-1/2"
      style={{ transform: 'translate(-50%, -50%)' }}
    />
  );

  if (isEditable) {
    return (
      <button
        onClick={() => {
          const selectedValue = Math.round((lowerLimit + upperLimit) / 2);
          handleEdit(selectedValue);
        }}
        className="tw-p-3 tw-w-full tw-aspect-square tw-relative tw-min-w-[52px]"
        style={style}
      >
        {isSelected && isSelectedUI}
        {hasBothGroups ? (
          bothGroupsUI
        ) : (
          <>
            {hasGroupOne && groupOneUI}
            {hasGropTwo && groupTwoUI}
          </>
        )}
      </button>
    );
  }

  return (
    <div className="tw-p-3 tw-w-full tw-aspect-square tw-relative tw-min-w-[52px]" style={style}>
      {isSelected && isSelectedUI}
      {hasBothGroups ? (
        bothGroupsUI
      ) : (
        <>
          {hasGroupOne && groupOneUI}
          {hasGropTwo && groupTwoUI}
        </>
      )}
    </div>
  );
};

export default WorkingStylesCell;
